import { DateTime as DateTime$1 } from "../../../../components/DateTime/index.js";
import { UserName } from "../../../Users/shared/UserName.js";
import { SelectMultiOptionWrapper } from "../../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../../components/Select/SelectAsyncRPC.js";
import { useRegionContext } from "../../../Regions/contexts/RegionContext.js";
import { SelectLocation } from "../SelectLocation.js";
import { LocationAndGroupNames } from "../LocationAndGroupNames.js";
import { useState } from "react";
import { ColorSquare } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Locations/shared/LocationLogEntries/SelectLocationLogEntry.tsx
var Base = ({ entry }) => {
	if (!entry) return null;
	const { activityTypeTags, createdAt, createdByUser, entryType, title } = entry;
	return /* @__PURE__ */ jsxs("div", {
		className: "inline-flex w-full justify-between",
		children: [/* @__PURE__ */ jsx("div", {
			className: "gap-x-sm inline-flex",
			children: /* @__PURE__ */ jsxs("div", {
				className: "truncate",
				children: [
					entry.locationId && /* @__PURE__ */ jsx("div", {
						className: "text-sm font-bold",
						children: /* @__PURE__ */ jsx(LocationAndGroupNames, { locationAndGroupIds: [entry.locationId] })
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "font-small text-color-subtle truncate text-sm",
						children: [/* @__PURE__ */ jsx(ColorSquare, {
							color: entryType.color,
							marginRight: true
						}), entryType.name]
					}),
					/* @__PURE__ */ jsx("div", {
						className: "truncate",
						children: title
					}),
					/* @__PURE__ */ jsx("div", { children: activityTypeTags?.map((tag, i) => /* @__PURE__ */ jsxs("span", {
						className: "text-color-subtle text-sm font-medium",
						children: [tag.title, i + 2 <= activityTypeTags.length && ", "]
					}, tag.id)) })
				]
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col",
			children: [/* @__PURE__ */ jsx(DateTime$1, {
				mode: "datetime",
				timestamp: createdAt
			}), /* @__PURE__ */ jsx(UserName, { user: createdByUser })]
		})]
	});
};
var SelectedSingle = (entry) => /* @__PURE__ */ jsx(Base, { entry });
var SelectedMulti = (entry, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsx("div", {
		className: "mx-sm max-w-full",
		children: /* @__PURE__ */ jsx(Base, { entry })
	})
});
var ListItem = (option) => /* @__PURE__ */ jsx(Base, { entry: option });
var responseOptionsExtractor = (data) => data?.entries;
var SelectLocationLogEntry = ({ bypassLocationSelect = false, entryIds, entryTypeIds, limit = 15, locationId: initialLocationId, multi, value, ...atalayaSelectProps }) => {
	const [hasInitialLocationId] = useState(!!initialLocationId);
	const [locationId, setLocationId] = useState(initialLocationId);
	const regionCtx = useRegionContext();
	if (!locationId && (!value?.length || !value) && !bypassLocationSelect) return /* @__PURE__ */ jsx(SelectLocation, {
		label: atalayaSelectProps.label,
		onChangeValue: setLocationId,
		placeholder: "Select Location...",
		regionIds: regionCtx ? [regionCtx?.regionId] : void 0,
		value: locationId
	});
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderListItem: ListItem,
		RenderSelectedMulti: SelectedMulti,
		RenderSelectedSingle: SelectedSingle,
		args: {
			entryIds,
			entryTypeIds,
			locationId
		},
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ title }) => title,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Locations.GetLocationLogEntryList.v1,
		requestFilterProp: "entryIds",
		responseOptionsExtractor,
		selectedArgs: { locationId },
		value,
		...atalayaSelectProps,
		onChangeValue: (value) => {
			if (!value || !value?.length) {
				atalayaSelectProps.onChangeValue?.(value);
				setLocationId(initialLocationId);
			} else atalayaSelectProps.onChangeValue?.(value);
		}
	});
};
//#endregion
export { SelectLocationLogEntry };

//# sourceMappingURL=SelectLocationLogEntry.js.map